<app-header></app-header>
<section class="container-xxl">
<!-- BREADCRUMB AREA - STARTS -->
<div class="breadcrumb-area">

    <!-- for content page  -->
    <nav aria-label="breadcrumb mb-0">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/">{{'Home'| translate}}</a></li>
            <li class="breadcrumb-item"><a routerLink="/">{{'StatisticalData' | translate}}</a></li>
            <li class="breadcrumb-item"><a href="javascript:void(0);" class="active-nemu">{{'Stock' | translate }}</a>
            </li>
        </ol>
    </nav>
</div>
<!-- BREADCRUMB AREA - ENDS -->

<div class="inner-page">
    <div class="inner-page-details">

        <!-- for content page  -->
        <div class="row">
            <div class="col-lg-2 col-xl-3 col-xxl-2">
                <div style="height:100%;">
                    <app-statistical-data-sidenav></app-statistical-data-sidenav>
                </div>
            </div>
            <div class="col-lg-10 col-xl-9 col-xxl-10">
                <!-- INNER CONTENT - STARTS -->
                <div class="statistical-content inner-page-sidedetails">
                    <div id="section-New"></div>
                    <div class="details">
                        <div class="title d-flex justify-content-between">
                            <h2>{{'Stock' | translate }}</h2>
                            <div class="view-data">
                                <ul>
                                    <li><a (click)="Toggle(true)" id="stockchart" class="Toggle"><i class="fa fa-bar-chart"></i></a></li>
                                    <li><a (click)="Toggle(false)" id="stocktbl" class="Toggle active"><i class="fa fa-table"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="description">
                            <div class="inner-content">
                                <div class="row">
                                    <div div class="col-lg-12" [hidden]="ShowTabView">
                                        <div class="content-details">
                                            <div class="top-tab d-flex justify-content-between align-items-center">
                                                <h4 class="mb-0">{{'Stock' | translate }} {{this.selectedYear}}
                                                    <small>({{ 'FiginLMTs' | translate}})</small>
                                                </h4>
                                                <div class="d-flex select-data align-items-center">
                                                    <div class="select-items">

                                                        <select class="form-select" [(ngModel)]="selectedState" (change)="onStateSelected()">
                                                            <option value="">-- {{'SelectState' | translate }} --</option>
                                                            <option *ngFor="let item of StateUTList" [value]="item.state_English">{{
                                                                (language=='English') ? item.state_English : item.state_Hindi
                                                                }}</option>

                                                        
                                                        </select>
                                                    </div>
                                                    <div class="select-items">
                                                        <select class="form-select" [(ngModel)]="selectedYear" (change)="onYearSelected()">
                                                            <option value="" selected>-- {{'SelectYear' | translate }} --</option>
                                                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                                <div class="table-responsive font-adjust">
                                                <table class="table table-sm table-hover" aria-labelledby="table">
                                                    <thead>
                                                        <tr>
                                                            <th>#{{'SlNo'| translate}}</th>
                                                            <th>{{'Zone' |translate }}</th>
                                                            <th>{{'State' |translate }}</th>
                                                            <th>{{'Date' |translate }}</th>
                                                            <th>{{'FCI'| translate}} {{'RiceStock'| translate}}</th>
                                                            <th>{{'FCI'| translate}} {{'WheatStock'| translate}}</th>
                                                            <th>{{'FCI'| translate}} {{'TotalStock'| translate}}</th>
                                                            <th>{{'State'| translate}} {{'RiceStock'| translate}}</th>
                                                            <th>{{'State'| translate}} {{'WheatStock'| translate}}</th>
                                                            <th>{{'State'| translate}} {{'TotalStock'| translate}}</th>
                                                            <th>{{'Central'| translate}} {{'RiceStock'| translate}}</th>
                                                            <th>{{'Central'| translate}} {{'WheatStock'| translate}}</th>
                                                            <th>{{'Central'| translate}} {{'TotalStock'| translate}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container *ngIf="getStockData.length > 0; else noDataTemplate">
                                                        
                                                        <tr *ngFor="let item of getStockData | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}; let i = index">
                                                            <td *ngIf="currentPage==1">{{i+1}}</td>
                                                            <td *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (i+1)}}</td> 
                                                            <td>{{language=='English'?item.zone_English:item.zone_Hindi}}</td>
                                                            <td>{{language=='English'?item.state_English:item.state_Hindi}}</td>
                                                            <td>{{item.date}}</td>
                                                           <td>
                                                             <!-- {{(item.fci_rice_stock % 1 === 0) ? item.fci_rice_stock :(item.fci_rice_stock | number: '1.5-5') }} -->
                                                             {{ NumberFormart(item.fci_rice_stock) }}
                                                            </td>

                                                           <td>
                                                            <!-- {{(item.fci_wheat_stock % 1 === 0) ?  item.fci_wheat_stock : (item.fci_wheat_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.fci_wheat_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.fci_total_stock % 1 === 0 ) ?  item.fci_total_stock : (item.fci_total_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.fci_total_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.state_rice_stock % 1 === 0) ?  item.state_rice_stock : (item.state_rice_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.state_rice_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.state_wheat_stock % 1 === 0) ?  item.state_wheat_stock : (item.state_wheat_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.state_wheat_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.state_total_stock % 1 === 0 ) ?  item.state_total_stock : (item.state_total_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.state_total_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.central_rice_stock % 1 === 0) ?  item.central_rice_stock : (item.central_rice_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.central_rice_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.central_wheat_stock % 1 === 0) ?  item.central_wheat_stock : (item.central_wheat_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.central_wheat_stock) }}
                                                        </td>

                                                           <td>
                                                            <!-- {{(item.central_total_stock % 1 === 0) ?  item.central_total_stock : (item.central_total_stock | number: '1.5-5') }} -->
                                                            {{ NumberFormart(item.central_total_stock) }}
                                                        </td>

                                                        </tr>
                                                    </ng-container>
                                                    </tbody>
                                                    <!-- <tfoot>
                                                        <tr>
                                                            <td [colSpan]="14">
                                                                <pagination-controls id="pg1" class="text-center pg1"
                                                                    (pageChange)="pageChanged($event)"></pagination-controls>
                                                            </td>
                                                        </tr>
                                                    </tfoot> -->
                                                </table>
                                            </div>

                                            <ng-template #noDataTemplate>

                                                <tr><td [colSpan]="14" [style.text-align]="'center'"><b>{{'Nodatafound' |translate}}</b></td></tr>
                                            </ng-template>

                                        </div>
                                        <div class="my-4" *ngIf="getStockData.length > 0">
        

                                            <pagination-controls id="pg1" class="text-center pg1"
                                                                    (pageChange)="pageChanged($event)"></pagination-controls>
                                    </div>
                                    </div>
                                    <div class="col-lg-12" [hidden]="!ShowTabView">
                                        <div class="content-details">
                                            <div class="top-tab d-flex justify-content-between align-items-center">
                                                <h4 class="mb-0">{{'Stock' | translate }} {{this.selectedYear}}
                                                    <small>({{ 'FiginLMTs' | translate}})</small>
                                                </h4>
                                                <div class="d-flex select-data align-items-center">
                                                    <div class="select-items">
                                                        <select class="form-select" [(ngModel)]="selectedState" (change)="onStateSelected()">
                                                            <option value="">-- {{'SelectState' | translate }} --</option>
                                                            <option *ngFor="let item of StateUTList" [value]="item.state_English">{{
                                                                language=='English'? item.state_English:item.state_Hindi
                                                                }}</option>
                                                          </select>
                                                    </div>
                                                    <div class="select-items">
                                                        <select class="form-select" [(ngModel)]="selectedYear" (change)="onYearSelected()">
                                                            <option value="">-- {{'SelectYear' | translate }} --</option>
                                                            <option *ngFor="let year of years" [value]="year" >{{ year }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="chart-stock"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- INNER CONTENT - ENDS -->
            </div>
        </div>
    </div>
</div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>